// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__19h7t","inputWrap":"Table_inputWrap__2P_F9","col":"Table_col__2Ahu-","bmiTooltip":"Table_bmiTooltip__ZNGCQ"};